import { PALETTE as P } from '../tokens'
import { useAuth } from '../context/AuthContext'
import { Wordmark } from './Wordmark'

/**
 * AgeRestrictedView — full-screen lock for accounts flagged
 * ``age_restricted`` (an existing user who supplied an under-18 DOB in the
 * backfill modal). Rendered by ProtectedRoute BEFORE anything else, so a
 * restricted user never slips into the app. Non-punitive copy; the only
 * action is to sign out. Their DOB was never stored — the flag is the
 * record.
 */
export function AgeRestrictedView() {
  const { logout } = useAuth()

  return (
    <div style={{
      minHeight: '100dvh',
      background: P.bg,
      color: P.text,
      fontFamily: "'DM Sans', sans-serif",
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '40px 28px',
    }}>
      <div style={{ maxWidth: 360 }}>
        <Wordmark style={{ marginBottom: 28, opacity: 0.9 }} />
        <h1 style={{
          fontFamily: "'Playfair Display', Georgia, serif",
          fontSize: 28,
          fontStyle: 'italic',
          fontWeight: 400,
          lineHeight: 1.2,
          marginBottom: 16,
        }}>
          Thank you for your interest.
        </h1>
        <p style={{
          fontSize: 14.5,
          color: P.textMid,
          lineHeight: 1.7,
          fontWeight: 300,
          marginBottom: 28,
        }}>
          Haiven is currently built for adults 18 and over, so we&rsquo;re not
          able to offer you access right now. We hope to welcome you when the
          time is right.
        </p>
        <button
          onClick={logout}
          style={{
            width: '100%',
            maxWidth: 240,
            padding: 15,
            background: 'none',
            border: `1.5px solid ${P.border}`,
            borderRadius: 14,
            cursor: 'pointer',
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 14,
            fontWeight: 400,
            color: P.textMid,
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  )
}
